import type { ReactNode } from 'react';
import lightUrl from './paige-logo.png';
import darkUrl from './paige-logo-dark.png';
import './brand.css';

export interface PaigeLogoProps {
  /** Rendered height in CSS pixels; the asset is 1830 x 400, so width follows. */
  height?: number;
  className?: string;
  /** Force one variant regardless of theme, for a surface that is always light (a white brand band). */
  variant?: 'auto' | 'light' | 'dark';
}

/**
 * The legacy Paige logo, unchanged in light mode. Dark mode uses the dark-surface variant (the
 * lettering in light grey, the mark untouched) instead of a backing slab; the theme decides which
 * of the two images shows (docs/ui-concept.md, Branding).
 */
export function PaigeLogo({ height = 28, className, variant = 'auto' }: PaigeLogoProps): ReactNode {
  const width = Math.round((height * 1830) / 400);
  const classes = ['pui-logo', `pui-logo--${variant}`, className].filter(Boolean).join(' ');
  return (
    <span className={classes} style={{ width, height }}>
      <img
        src={lightUrl}
        alt="Paige"
        width={width}
        height={height}
        className="pui-logo__light"
        draggable={false}
      />
      <img
        src={darkUrl}
        alt=""
        width={width}
        height={height}
        className="pui-logo__dark"
        draggable={false}
        aria-hidden="true"
      />
    </span>
  );
}
